export default {
  views: {
    subGroups: {
      assign: "Alt qrupları təyin edin",
      tagManager: "Etiket meneceri: Qrupunuzu seçin",
      successAssign: "Heyrətamiz! Qrupunuz üçün Alt Qrupları yenilədiniz.",

      errors: {
        assign: "uh oh! Alt qrup təyin etmək mümkün deyil"
      },

      table: {
        firstName: "Ad",
        lastName: "Soyad",
        username: "İstifadəçi adı",
        subGroup: "Alt qrup"
      }
    },

    classes: {
      label: "Qrup",

      editGroup: "Qrupu redaktə edin - Addım",
      addGroup: "Qrup əlavə edin - Addım",
      classesCount: "{count} qruplar",

      errors: {
        group: "Qrup məlumatları yüklənmədi.",
        update: "Qrup yenilənmədi. Daha sonra yenidən cəhd edin",
        create: "Qrup yaratmaq alınmadı",
        emptyList: "Seçilmiş məktbədə hələ heç bir qrupunuz yoxdur."
      },

      messages: {
        create: "Qrup uğurla yaradıldı."
      }
    },

    schools: {
      label: "Məktəb",

      errors: {
        emptyList: "Mövcud məktəbiniz yoxdur.",
        fetchError: "Məktəbləri gətirmək alınmadı"
      }
    },

    teachers: {
      teachersCount: "{count} müəllimlər",

      errors: {
        emptyList: "Hələ müəlliminiz yoxdur.",
        details: "Müəllim məlumatlarını gətirmək alınmadı.."
      },

      titles: {
        edit: "Müəllimi redaktə edin"
      },

      messages: {
        create: "Müəllim uğurla yaradıldı!",
        update: "Müəllim yeniləndi!"
      }
    },

    grammarToGo: {
      title: "Qrammatikaya Keçin"
    },

    home: {
      wantToAssign: "Dərs tapşırmaq istəyirəm",
      whatStudentsDo: "Şagirdləriniz Little Bridge-də nə edirlər?",
      howManyCountries: "Şagirdlərinizin neçə ölkədə DigiPal-ları var?",
      numActivities: "Şagirdləriniz nə qədər fəaliyyət yerinə yetirib?",
      numFriends: "Şagirdlərinizin neçə DigiPal-ı var?",
      numMessages: "Şagirdləriniz neçə mesaj göndərib?",

      errors: {
        dashboard: "Alətlər paneli məlumatlarını gətirmək alınmadı."
      }
    },

    knowledgeBase: {
      title: "Bilik Bazası",

      errors: {
        fetch: "Bilik bazasını gətirmək alınmadı",
        details: "Bilik bazası təfərrüatını gətirmək alınmadı"
      }
    },

    lessons: {
      label: "Dərs",

      subgroups: "Alt Qruplar",

      messages: {
        setLessonsAuto:
          "Little Bridge Şagirdlərinizin dərslərini avtomatik planlaşdıracaq. Öz sürətləri ilə öyrənəcəklər. Şagirdlərinizə dərs tapşırmaqla bunu istənilən vaxt ləğv edə bilərsiniz."
      },

      hasBeenAssigned: "Bu dərs tapşırılıb.",
      assignAnother: "Başqa dərs tapşırın",
      assignMyself: "Dərsləri özüm tapşırmaq istəyirəm",
      assignAuto: "Little Bridge-in dərsləri avtomatik tapşırmasını istəyirəm",
      lessonId: "Dərs {lessonId}",
      set: "Dərs təyin",
      activity: "Fəaliyyət",
      resources: "Qaynaqlar",

      statuses: {
        selected: "Dərs seçildi",
        archived: "Arxivləşdirildi",
        current: "Hazırkı dərs",
        unassigned: "Tapşırılmayıb"
      },

      stepper: {
        titles: {
          step1: "Addım 1 - Kimə dərs tapşırmaq istəyirsiniz?",
          step2: "Addım 2 - Dərs seçin",
          step3: "Addım 3 - Təsdiqləyin"
        }
      },

      errors: {
        fetch: "Dərsləri gətirmək alınmadı."
      }
    },

    reports: {
      title: "Hesabat Generatoru",
      type: "Hesabat növü",
      generate: "Hesabat yaradın",

      level: "Səviyyə hesabatı",
      lesson: "Dərs hesabatı",
      test: "Checkpoint hesabatı",
      diagnostic: "Diaqnostik hesabat",
      baseline: "Baza hesabatı",
      progress: "Tərəqqi testi",
      students: "tələbələr",

      download: {
        pdf: "PDF olaraq endirin",
        csv: "CSV olaraq endirin",
        lessonPlan: "PDF dərs planını endirin"
      },

      errors: {
        generate: "Hesabat hazırlamaq alnmadı. Daha sonra yenidən cəhd edin."
      }
    },

    students: {
      label: "Tələbələr",
      editStudent: "Tələbəni redaktə edin",
      stundentsCount: "{count} tələbələr",
      add: "Şagird əlavə edin",
      saveAndDownload: "Şagirdlər siyahısını yaddaşda saxlayın və endirin",
      download: "Şagirdlər siyahısını endirin",

      import: {
        step: "addım: Şagirdləri idxal edin - addım ",
        clickVideo: "Qısa təlim videosunu izləmək üçün buraya vurun",
        copyPasteFirst:
          "Şagirdlərin adlarını kopyalayıb 'Ad' mətn qutusuna əlavə edin.Bir dəfəyə 100-ə qədər Şagird idxal edə bilərsiniz.",
        copyPasteLast:
          "Şagirdlərin soyadlarını kopyalayıb 'Soyad' mətn qutusuna əlavə edin.",
        confirm:
          "Əla! İndi isə hər şeyin doğru olduğunu yoxlayaq. Hər hansı dəyişiklik etmək istəyirsinizsə, geri qayıda bilərsiniz. Yoxlayın: hər Şagirdin adı və soyadı doğru şəkildə uyğun gəlir.",
        thoseStudentsAdded:
          "Bu Şagirdlər hesabınıza əlavə edildi. Təhlükəsizlik məqsədləri üçün parolları yenidən endirə bilməyəcəksiniz. Təhlükəsiz mövqedəki faylı yaddaşda saxladığınıza əmin olun. Fayl avtomatik endirilməsə, indi 'Şagird siyahısını endir' düyməsinə klikləyin.",
        note: "Qeyd - idxal üçün 100 tələbə limiti var."
      },

      messages: {
        create: "Şagird uğurla yaradıldı!",
        update: "Şagird yeniləndi!"
      },

      errors: {
        emptyList: "Hələ Şagirdiniz yoxdur.",
        details: "Şagird məlumatlarını gətirmək alınmadı.",
        import:
          "Ay yay! Xəta baş verib. Adları yenidən kopyalayıb əlavə etməyi sınaya bilərsiniz?",
        importPaste: "Ay yay! {Column} sütununa heç bir şey əlavə etməmisiniz."
      }
    }
  },

  stepsLabels: {
    step4: "Addım 4 - Təsdiqləyin"
  },

  common: {
    next: "Sonrakı",
    ok: "Oldu",
    unassigned: "Təyin olunmayıb",
    close: "Bağla",
    nextConfirm: "Növbəti addım - təsdiq edin",
    continue: "Davam et",
    returnHome: "Əsas səhifəyə qayıdın",
    finish: "Yekunlaşdır",
    confirm: "Təsdiqlə",
    save: "Yaddaşda saxla",
    siteUsage: "Saytdan istifadə",
    reset: "Sıfırla"
  },

  errors: {
    basic: "Məlumat yüklənmədi.",
    unexpected: "Gözlənilməz xəta baş verdi.",
    admin: "Bunu etməyə icazəniz yoxdur. Hesab inzibatçısı ilə əlaqə saxlayın."
  },

  tables: {
    lessons: {
      level: "Səviyyə",
      topic: "Mövzu",
      lesson: "Dərs",
      summary: "Xülasə",
      content: "Məzmun",
      status: "Status",
      testCategory: "Test kateqoriyası"
    },

    reports: {
      firstName: "Ad",
      lastName: "Soyad",
      username: "İstifadəçi adı",
      lesson: "Dərs",
      topic: "Mövzu",
      scoreForActivity: "Xal - {activityId}",
      correct: "Doğru",
      progress: "İrəliləyiş",
      levelNumber: "Səviyyə",
      lessonName: "Dərs adı",
      activity1: "Fəaliyyət 1",
      activity2: "Fəaliyyət 2",
      activity3: "Fəaliyyət 3",
      activity4: "Fəaliyyət 4"
    },

    classes: {
      group: "Qrup",
      subgroup: "Alt qrup",
      teacher: "Müəllim",
      numberOfStudents: "Şagirdlərin sayı",
      lesson: "Cari dərs",

      errors: {
        failedDelete:
          "Qrupu (qrupları) silmək olmadı. Daha sonra yenidən cəhd edin.",
        canBeAssign:
          "Şagirdlər bir dəfəyə yalnız bir qrupa təyin edilə bilər. Bu qrupa təyin olunmuş istənilən Şagird cari qrupundan çıxarılacaq."
      }
    }
  },

  components: {
    noActivitiesInLesson: "Bu dərsdə fəaliyyət yoxdur.",
    selectAll: "Hamısını seç",
    groupName: "Qrup adı",
    assignStudents: "Növbəti addım - şagirdlər təyin edin",
    assignTeachers: "Növbəti addım - müəllimlər təyin edin",
    noData: "Məlumat yoxdur.",
    videoSupport:
      "Təəssüf ki, brauzeriniz yerləşdirilmiş videoları dəstəkləmir.",
    generateUsername: "Yeni istifadəçi adı yaradın",
    password: "Parol",
    admin: "admindir",
    view: "Bax",
    goBack: "Qeri gayıt",
    openLanguageMenu: "Dil menyusunu açın",
    isAdmin: "Admindir",
    selectALevel: "Səviyyə seçin",

    warnings: {
      deleteClasses: "{clasessNames} siniflərini silmək üzrəsiniz"
    },

    errors: {
      selectGroups: "Əvvəlcə qrupları seçin.",
      editOneGroupAtOnce: "Bir dəfəyə yalnız 1 qrupu redaktə edə bilərsiniz",

      selectStudents: "Əvvəlcə Şagirdləri seçin.",
      deleteStudents: "Şagirdləri silmək üzrəsiniz ",
      editOneStudentAtOnce:
        "Bir dəfəyə yalnız 1 Şagirdi redaktə edə bilərsiniz",
      failedToDeleteStudents:
        "Şagirdləri silmək alınmadı. Daha sonra yenidən cəhd edin.",
      selectTeachers: "Əvvəlcə müəllimləri seçin.",
      deleteTeachers: "Müəllimləri silmək üzrəsiniz",
      editOneTeacherAtOnce:
        "Bir dəfəyə yalnız 1 müəllimi redaktə edə bilərsiniz",
      failedToDeleteTeachers:
        "Müəllim(lər) silinmədi. Daha sonra yenidən cəhd edin.",
      teacherNames: "Zəhmət olmasa müəllimin ad və soyadlarını doldurun.",
      failedUsername:
        "İstifadəçi adı yaratmaq uğursuz oldu. Biraz sonra yenidən cəhd edin.",
      teacherEdit: "Müəllimin istifadəçi adını düzəltmək mümkün deyil"
    }
  },

  navigation: {
    open: "Menyunu açın",
    goToDashboard: "Müəllimlər panelinə keçin",
    teachers: "Müəllimlər",
    students: "Şagirdlər",
    lessons: "Dərslər",
    groups: "Qruplar",
    reports: "Hesabat Yaradan",
    grammar: "Qrammatikaya Keçin",
    knowledge: "Bilik Bazası",
    logout: "Çıxış edin",
    subgroups: "Alt qrupları təyin edin"
  }
};
